const SERVICES_LIST_CACHE_KEY = 'service-list-key';
const GET_SERVICE_DETAILS_KEY = 'get-service-details-key';

export { GET_SERVICE_DETAILS_KEY, SERVICES_LIST_CACHE_KEY };
//# sourceMappingURL=serviceList.js.map
